import { api } from './base';
import { Employee } from './employee.api';

export interface InternalSite {
  id: number;
  status: number;
  name: string;
  title: string;
  description: string;
  create_time: string;
  modify_time: string;
  perms: any;
  address?: string;
  labels?: Array<string>;
  visible?: boolean;
  accessible?: boolean;
  access_key?: string;
}

export interface ListSitesResult {
  sites: Array<InternalSite>;
}

export const siteAdminApis = {
  listSites() {
    return api.get<ListSitesResult>('/admin/sites');
  },
  async getAdmins(siteId: number, admin_type: string): Promise<Array<Employee>> {
    return await api.get(`/admin/sites/${siteId}/admins/${admin_type}`).then(result => result.site_admins);
  },
  updateSite(site: InternalSite): Promise<InternalSite> {
    if (site.id != null) {
      return api.put(`/admin/sites/${site.id}`, site).then(reuslt => reuslt.site);
    } else {
      return api.post(`/admin/sites`, site).then(result => result.site);
    }
  },
  updateSiteAddress(site: InternalSite): Promise<InternalSite> {
    return api.put(`/admin/sites/${site.id}/address`, site).then(reuslt => reuslt.site);
  },
  async deleteSite(siteId: number) {
    if (siteId) {
      await api.delete(`/admin/sites/${siteId}`);
    }
  },
  grantAdmin(siteId: number, employeeId: number, admin_type: string) {
    return api.post<void>(`/admin/sites/${siteId}/admins`, [{ id: employeeId, checked: true, admin_type: admin_type }]);
  },
  revokeAdmin(siteId: number, employeeId: number, admin_type: string) {
    return api.post<void>(`/admin/sites/${siteId}/admins`, [
      { id: employeeId, checked: false, admin_type: admin_type }
    ]);
  }
};
